module.exports = __webpack_public_path__ + "img/ubcS.ad76cf2a.png";